<template>
  <moe-page>
    <moe-top></moe-top>
    <div class="top_box flex Flexjustify Flexalign flexcolumn">
      <!-- <div class="filter_box" v-for="(item, index) in filterList" :key="index">
        <div class="flex FlexBetween">
          <div class="flex">
            <div>{{ item.name }}:</div>
            <div v-for="(sitem, sindex) in item.list" :key="sindex" class="area_info">
              {{ sitem.label }}
            </div>
          </div>
          <div class="filter flex Flexalign FlexEvenly cursor_pointer" v-if="item.showMore">
            <el-image class="filter_icon" :src="imgPath('filter_icon.png')"></el-image>
            <div>更多</div>
            <el-image class="filter_icon" :src="imgPath('arrow_up.png')"></el-image>
          </div>
        </div>
        <div v-if="item.subList" class="sublist_box flex">
          <div class="opacity_box">{{ item.name }}:</div>
          <div class="flex-1 flex area_box FlexBetween">
            <div class="flex">
              <div class="area_info" v-for="(ssitem, ssindex) in item.subList" :key="ssindex">
                {{ ssitem.label }}
              </div>
            </div>
            <div class="flex more_box Flexalign">
              <div>更多</div>
              <el-image class="filter_icon" :src="imgPath('arrow_up.png')"></el-image>
            </div>
          </div>
        </div>
      </div> -->
      <div class="filter_box flex">
        <div>学段:</div>
        <div class="flex FlexWrap flex-1">
          <div class="area_info cursor_pointer" :class="[selectedInfo.stageId == '' ? 'active_area_info' : '']"
            @click="selectStage('')">
            不限
          </div>
          <div v-for="(item, index) in stageList" :key="index" class="area_info cursor_pointer"
            :class="[selectedInfo.stageId == item.stageId ? 'active_area_info' : '']"
            @click="selectStage(item.stageId)">
            {{ item.stageName }}
          </div>
        </div>
      </div>
      <div class="filter_box flex">
        <div>学科:</div>
        <div class="flex FlexWrap flex-1">
          <div class="area_info cursor_pointer" :class="[selectedInfo.subjectId == '' ? 'active_area_info' : '']"
            @click="selectSubjet('')">
            不限
          </div>
          <div v-for="(item, index) in subjectList" :key="index" class="area_info cursor_pointer"
            :class="[selectedInfo.subjectId == item.subjectId ? 'active_area_info' : '']"
            @click="selectSubjet(item.subjectId)">
            {{ item.subjectName }}
          </div>
        </div>
      </div>
      <div class="filter_box flex">
        <div>版本:</div>
        <div class="flex FlexWrap flex-1">
          <div class="area_info cursor_pointer" :class="[selectedInfo.publisherId == '' ? 'active_area_info' : '']"
            @click="selectPublisher('')">
            不限
          </div>
          <div v-for="(item, index) in publisherList" :key="index" class="area_info cursor_pointer" :class="[
            selectedInfo.publisherId == item.publisherId ? 'active_area_info' : '',
          ]" @click="selectPublisher(item.publisherId)">
            {{ item.publisherName }}
          </div>
        </div>
      </div>
      <div class="filter_box flex">
        <div>学册:</div>
        <div class="flex FlexWrap flex-1">
          <div class="area_info cursor_pointer" :class="[selectedInfo.termId == '' ? 'active_area_info' : '']"
            @click="selectTerm('')">
            不限
          </div>
          <div v-for="(item, index) in termList" :key="index" class="area_info cursor_pointer"
            :class="[selectedInfo.termId == item.termId ? 'active_area_info' : '']" @click="selectTerm(item.termId)">
            {{ item.termName }}
          </div>
        </div>
      </div>
      <div class="filter_box flex">
        <div>难度:</div>
        <div class="flex FlexWrap flex-1">
          <div class="area_info cursor_pointer" :class="[selectedInfo.courseDifficulty == '' ? 'active_area_info' : '']"
            @click="selectDifficulty('')">
            不限
          </div>
          <div v-for="(item, index) in difficultyList" :key="index" class="area_info cursor_pointer" :class="[
            selectedInfo.courseDifficulty == item.difficultyId
              ? 'active_area_info'
              : '',
          ]" @click="selectDifficulty(item.difficultyId)">
            {{ item.difficultyName }}
          </div>
        </div>
      </div>
    </div>
    <div class="hot_sell_course flex Flexjustify Flexalign flexcolumn">
      <div class="hot_sell_course_top FlexBetween flex Flexalign">
        <div class="flex Flexalign">
          <div class="hot_sell_course_top_title">全部课程</div>
          <div class="flex Flexalign cursor_pointer" v-for="(item, index) in hotCourseList" :key="index" :class="[
            item.value == hotCourseValue ? 'active_text' : '',
            'hot_course_text',
          ]" @click="changeSort(item)">
            {{ item.label }}
          </div>
          <div class="flex Flexalign flexcolumn mar_left_5" v-if="hotCourseValue == 3">
            <el-image class="sort_gray_icon" :src="iconPath('sort_gray_icon.png')"
              v-if="selectedInfo.isAsc == 'desc'"></el-image>
            <el-image class="sort_gray_icon sort_green_icon" :src="iconPath('sort_green_icon.png')"
              v-if="selectedInfo.isAsc == 'desc'"></el-image>
            <el-image class="sort_gray_icon rotage_180" :src="iconPath('sort_green_icon.png')"
              v-if="selectedInfo.isAsc == 'asc'"></el-image>
            <el-image class="sort_gray_icon sort_green_icon rotage_180" :src="iconPath('sort_gray_icon.png')"
              v-if="selectedInfo.isAsc == 'asc'"></el-image>
          </div>
        </div>
        <!-- <div class="more_btn flex Flexalign Flexjustify">
          <el-checkbox v-model="memberSelected" label="会员课程" size="large" />
        </div> -->
      </div>
      <courseList :selectedInfo="selectedInfo"></courseList>
    </div>
    <moe-bottom></moe-bottom>
    <moe-right></moe-right>
  </moe-page>
</template>
<script>
import courseList from "@/components/index/courseList.vue";
import { mapState } from "vuex";
export default {
  name: "GjkcH5Index",
  components: {
    courseList,
  },
  computed: {
    ...mapState({
      stageList: (state) => state.filter.stageList,
      subjectList: (state) => state.filter.subjectList,
      publisherList: (state) => state.filter.publisherList,
      termList: (state) => state.filter.termList,
      difficultyList: (state) => state.filter.difficultyList,
      userInfo: (state) => state.userInfo,
      selectCourseType: (state) => state.user.selectCourseType,
    }),
  },
  watch: {
    selectCourseType: {
      handler(value) {
        this.selectedInfo.typeId = value;
      },
      deep: true,
      immediate: true
    },
  },
  data() {
    return {
      selectedInfo: {
        shopId: "", // 商家Id
        courseName: "", // 课程名
        stageId: "", // 所属学段ID
        gradeId: "", // 所属年级ID
        subjectId: "", // 所属学科ID
        termId: "", // 所属学期ID
        publisherId: "", // 所属版本ID
        courseBookType: "", // 课程课本类型（1=课本课程，2=自定义课程）
        textbookId: "", // 所属教材ID
        courseDifficulty: "", // 课程难度
        learningStyle: "", // 学习方式（1=不限、2=闯关学习）
        saleMethod: "", // 售卖方式（1=免费，2=付费）
        pointsUsable: "", // 积分抵扣（1=允许，2=不允许）
        page: 1, // 页码
        pageSize: 8, // 单页数量
        orderByColumn: '', // 排序字段
        isAsc: 'desc', //升降序
        typeId: '',  // 课程类型
      },
      hotCourseList: [
        { label: "最新课程", value: 0, field: '' },
        { label: "最多购买", value: 1, field: 'order' },
        { label: "最多好评", value: 2, field: 'good_appraise' },
        { label: "价格", value: 3, field: 'price' },
      ],
      hotCourseValue: 0,
      memberSelected: false,
      filterList: [
        {
          name: "地区",
          list: [
            { label: "不限", value: "0" },
            { label: "江宁", value: "1" },
            { label: "浦口", value: "0" },
            { label: "栖霞", value: "0" },
            { label: "鼓楼", value: "0" },
            { label: "秦淮", value: "0" },
            { label: "雨花台", value: "0" },
            { label: "六合", value: "0" },
            { label: "建邺", value: "0" },
            { label: "玄武", value: "0" },
            { label: "溧水", value: "0" },
            { label: "滨江开发区", value: "0" },
            { label: "高淳", value: "0" },
          ],
          subList: [
            { label: "不限", value: "0" },
            { label: "江宁", value: "1" },
            { label: "浦口", value: "0" },
            { label: "栖霞", value: "0" },
            { label: "鼓楼", value: "0" },
            { label: "秦淮", value: "0" },
            { label: "雨花台", value: "0" },
          ],
          showMore: true,
          showFilter: true,
        },
      ],
    };
  },

  mounted() {
    let selectedParams = this.$Jump.getUrlParams(window.location.hash.split("?")[1])
      .selectedParams;
    if (selectedParams) {
      this.selectedInfo = JSON.parse(selectedParams);
    }
  },

  methods: {
    // 排序字段
    changeSort(info) {
      this.hotCourseValue = info.value;
      this.selectedInfo.orderByColumn = info.field;
      // 价格排序时最好只筛选收费课程
      if (info.value == 3) {
        this.selectedInfo.saleMethod = 2;
        this.selectedInfo.isAsc = (this.selectedInfo.isAsc=="desc"?'asc':'desc')
      } else {
        this.selectedInfo.saleMethod = '';
        this.selectedInfo.isAsc = "desc"
      }
    },
    // 选择学段
    selectStage(value) {
      this.selectedInfo.stageId = value;
    },
    // 选择学科
    selectSubjet(value) {
      this.selectedInfo.subjectId = value;
    },
    // 选择版本
    selectPublisher(value) {
      this.selectedInfo.publisherId = value;
    },
    // 选择学册
    selectTerm(value) {
      this.selectedInfo.termId = value;
    },
    // 难度选择
    selectDifficulty(value) {
      this.selectedInfo.courseDifficulty = value;
    },
    changeStage(info) {
      this.stageValue = info.value;
    },
  },
};
</script>
<style lang="scss" scoped>
.btn {
  width: 140px;
  height: 36px;
  background: linear-gradient(90deg, #00d5c2, #00d498);
  border-radius: 18px;
  color: #fff;
  line-height: 36px;
  text-align: center;
}

.top_box {
  width: 100%;
  padding: 20px 0;

  .filter_box {
    width: $pageMainWidth;
    line-height: 32px;
    margin-bottom: 10px;

    .area_info {
      padding: 0 11px;
      box-sizing: border-box;
      margin-left: 10px;
    }

    .active_area_info {
      color: #13d6aa;
    }

    .filter {
      width: 95px;
      height: 32px;
      border-radius: 5px;
      border: 1px solid #e1e1e1;
      line-height: 32px;

      .filter_icon {
        width: 18px;
        height: 18px;
      }
    }
  }

  .sublist_box {
    margin-top: 10px;

    .opacity_box {
      opacity: 0;
    }

    .area_box {
      margin-left: 10px;
      height: 45px;
      background: #f3f3f3;
      border-radius: 10px;
    }

    .area_info {
      padding: 0 11px;
      box-sizing: border-box;
      margin-left: 10px;
      line-height: 45px;
    }

    .more_box {
      height: 45px;
      margin-right: 10px;
    }

    .filter_icon {
      width: 18px;
      height: 18px;
    }
  }
}

.hot_sell_course {
  width: 100%;
  background: #f3f3f3;
  border-radius: 100px 100px 0px 0px;
  padding: 30px 0;

  .hot_sell_course_top {
    width: $pageMainWidth;

    .hot_sell_course_top_title {
      font-weight: bold;
      font-size: 24px;
      color: #000000;
    }

    .hot_course_text {
      color: #999999;
      margin-left: 26px;
    }

    .sort_gray_icon {
      width: 10px;
      height: 6px;
    }

    .rotage_180 {
      transform: rotate(180deg);
    }

    .sort_green_icon {
      margin-top: 5px;
    }

    .active_text {
      color: #13d6aa;
    }
  }

  .more_btn {
    width: 70px;
    height: 35px;
    background: #f5f6f8;
    border-radius: 18px;
    color: rgba(153, 153, 153, 1);
  }
}

.course_rank {
  width: 100%;
  background: #ffffff;
  padding: 30px 0;
  background: rgba(243, 243, 243, 1);

  .week_course_rank {
    width: $pageMainWidth;
    font-weight: bold;
    font-size: 24px;
    color: #000000;
  }
}
</style>
